<button class="fab"
        type="button"
        (click)="openOverlay()">
    <app-svg use="filter-list"></app-svg>
    <span>{{ 'CATALOG.FILTER.HEADLINE' | translate }}</span>
</button>
<ng-content select="[preContent]"></ng-content>
<dialog id="catalog-modal" modal="true" [disableInert]="true">
    @if(result?.results?.length > 0) {
        <button closeDialog> </button>
        <app-catalog-form aside
        [result]="result"></app-catalog-form>
    }
</dialog>
<pagination-page ga4ViewItemList
                 class="product-grid"
                 [item_list_name]="listName"
                 [item_list_id]="listId"
                 [items]="result?.results | mapGA4Items"
                 role="main"
                 [attr.aria-label]="'CATALOG.SEARCH.LABEL' | translate"
                 [state]="result?.state"
                 [max]="result?.totalResults"
                 [from]="result?.startingFrom"
                 [size]="size"
                 (update)="requestByUrl()">

    @defer (when result?.results?.length > 0) {
        @for (product of result?.results; track product.id) {
            <app-product-card [product]="product"></app-product-card>
        }
    } @placeholder {
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
    }
    @for (banner of banners; track banner?.id) {
        <layout-block-list-outlet
            [attr.grid-row-start]="banner?.row"
            [attr.grid-row-size]="banner?.rowSize > -2 ? banner?.rowSize : 1"
            [attr.grid-column-start]="banner?.column"
            [attr.grid-column-size]="banner?.columnSize > -2 ? banner?.columnSize : 1"
            [list]="banner?.banner?.layout"></layout-block-list-outlet>
    }
</pagination-page>
@if(result == null) {
    <button type="button"
            (click)="requestByUrl()">{{ 'CATALOG.SEARCH.RETRY' | translate }}</button>
}

<ng-content select="[postContent]"></ng-content>
